module.exports = __webpack_public_path__ + "media/images/flags/mo-ac9b1701934ac68456104bab8ff6c5c8.svg";